export const UPDATE_LIVROS = 'UDPATE_LIVROS'
export const ADD_LIVROS = 'ADD_LIVROS'
export const SET_LIVROS = 'SET_LIVROS'
export const REMOVE_LIVROS = 'REMOVE_LIVROS'
export const SET_LIVRO = 'SET_LIVRO'
export const OPEN_LIVRO = 'OPEN_LIVRO'
export const CLOSE_LIVRO = 'CLOSE_LIVRO'